import request from './axios';
import { baseUrl } from './config';

//导购登录
export const salesUserLogin = (paramData) => request({
  url: baseUrl + '/tmsapi/auth/salesUserLogin',
  meta: { isToken: false },
  method: 'get',
  params: paramData,
})

// 发送验证码
export const apiSendCode = (paramData) => request({
  url: baseUrl + '/core/sys/auth/sendCode',
  meta: { isToken: false },
  method: 'post',
  params: paramData
})

// 修改密码
export const apiEditPassword = (paramData) => request({
  url: baseUrl + '/tmsapi/auth/salesUserEditPassword',
  meta: { isToken: false },
  method: 'get',
  params: paramData
})

// 分页获取邀请码
export const apiInviteCodeList = (paramData) => request({
  url: baseUrl + '/tmsapi/inviteCodeInfo/getPageH5',
  meta: { isToken: false },
  method: 'get',
  params: paramData
})

// 生成邀请码
export const apiGetInviteCode = (paramData) => request({
  url: baseUrl + '/tmsapi/inviteCodeInfo/generateInviteCode',
  meta: { isToken: false },
  method: 'post',
  params: paramData
})